'use strict';
import template from './corteAnual.html';
import controller from './corteAnual.controller';

const CorteAnualComponent = {
  controller,
  template
};

export default CorteAnualComponent;


// WEBPACK FOOTER //
// ./src/app/components/listados/corte_anual/corteAnual.component.js